import { render } from "./DocumentEdit.vue?vue&type=template&id=c2afa360&scoped=true&ts=true"
import script from "./DocumentEdit.vue?vue&type=script&lang=ts"
export * from "./DocumentEdit.vue?vue&type=script&lang=ts"

import "./DocumentEdit.vue?vue&type=style&index=0&id=c2afa360&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2afa360"]])

export default __exports__